// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2WM6E","approved":"Status_approved__3Eu-h","rejected":"Status_rejected__CR_VX","expired":"Status_expired__1kVtZ","label":"Status_label__3Z-6v"};